import React, { Component } from "react";
import flatpickr from "flatpickr";
import moment from "moment";
import {
	decDaysToDate,
	FlatpickrLocalePT,
	formatDateToComputerDate,
	formatDateToLocalDate,
	getDiffBetweenTwoDates,
	incDaysToDate
} from "../../../shared/utils";
import PropTypes from "prop-types";
import Button from "../../../../shared/button/button";

export default class SalesDate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			startDate: this.props.startDate,
			endDate: this.props.endDate,
			maxIntervalBetweenDates: 365
		};
	}

	handleChangeDate = (instantSearch = false) => {
		return this.props.dateChanged(
			{
				startDate: formatDateToComputerDate(this.startDateFilter.selectedDates[0]),
				endDate: formatDateToComputerDate(this.endDateFilter.selectedDates[0])
			},
			instantSearch
		);
	};

	differenceBetweenInputedAndEndDate(inputedDate, dateEndDateFilter) {
		return getDiffBetweenTwoDates(
			formatDateToComputerDate(inputedDate),
			formatDateToComputerDate(formatDateToLocalDate(dateEndDateFilter))
		);
	}

	componentDidMount() {
		this.startDateFilter = flatpickr("#startDateFilter", {
			disableMobile: "true", // desabilita o datepicker nativo no browser mobile
			locale: FlatpickrLocalePT,
			name: "#startDateFilter",
			dateFormat: "d/m/Y",
			altFormat: "d/m/Y",
			allowInput: false,
			static: true,
			onChange: (selectedDates, dateStr) => {
				// Verifica se a nova data sera maior que a diferenca padrao definida via props
				if (
					this.differenceBetweenInputedAndEndDate(dateStr, this.endDateFilter.selectedDates[0]) >
					this.props.maxIntervalBetweenDates ||
					this.differenceBetweenInputedAndEndDate(dateStr, this.endDateFilter.selectedDates[0]) < 0
				) {
					this.endDateFilter.setDate(
						incDaysToDate(formatDateToComputerDate(dateStr), this.props.maxIntervalBetweenDates)
					);
				}

				this.handleChangeDate();
			}
		});

		this.endDateFilter = flatpickr("#endDateFilter", {
			disableMobile: "true", // desabilita o datepicker nativo no browser mobile
			locale: FlatpickrLocalePT,
			name: "#endDateFilter",
			dateFormat: "d/m/Y",
			altFormat: "d/m/Y",
			allowInput: false,
			static: true,
			onChange: (dates, dateStr) => {
				// Verifica se a nova data sera menor que a diferenca padrao definida via props
				console.log(
					"End date",
					this.differenceBetweenInputedAndEndDate(this.startDateFilter.selectedDates[0], dateStr)
				);
				console.log(
					"Diff between",
					getDiffBetweenTwoDates(dateStr, this.startDateFilter.selectedDates[0])
				);
				if (
					getDiffBetweenTwoDates(dateStr, this.startDateFilter.selectedDates[0]) >
					this.props.maxIntervalBetweenDates ||
					getDiffBetweenTwoDates(dateStr, this.startDateFilter.selectedDates[0]) <
					this.props.maxIntervalBetweenDates * -1 ||
					this.differenceBetweenInputedAndEndDate(this.startDateFilter.selectedDates[0], dateStr) >
					0
				) {
					this.startDateFilter.setDate(
						decDaysToDate(formatDateToComputerDate(dateStr), this.props.maxIntervalBetweenDates)
					);
				}

				this.handleChangeDate();
			}
		});

		if (this.props.startDate && this.props.endDate) {
			this.startDateFilter.setDate(formatDateToLocalDate(this.props.startDate));
			this.endDateFilter.setDate(formatDateToLocalDate(this.props.endDate));
		}
	}

	componentDidUpdate(prevProps) {
		const { selectedProgramId } = this.props;
		const { startDate, endDate } = this.state;
		const { startDateFilter, endDateFilter } = this;

		if (selectedProgramId !== prevProps.selectedProgramId) {
			if (selectedProgramId === 4) {
				startDateFilter.setDate(moment().startOf('year').format('DD/MM/YYYY'));
				endDateFilter.setDate(moment().endOf('year').format('DD/MM/YYYY'));
			} else if (selectedProgramId === 5) {
				startDateFilter.setDate('15/01/2020');
				endDateFilter.setDate(moment().format('DD/MM/YYYY'));
			} else {
				startDateFilter.setDate(formatDateToLocalDate(startDate));
				endDateFilter.setDate(formatDateToLocalDate(endDate));
			}
			this.handleChangeDate();
		}
	}

	render() {
		return (
			<div className="date-filter-period row">
				<div className="col-xs-16 col-lg-4">
					<div className="datepicker datepicker-margin-left">
						<input
							type="text"
							id="startDateFilter"
							name="startDateFilter"
							className={`form-control no-shadow no-bold col-xs-8`}
							placeholder="Escolha uma data"
							data-input
							required
							maxLength={10}
							autoComplete="off"
							data-action="date-period-filter-start-date"
						/>
						<i className="icon-calendar" />
					</div>
					<div className="label-period">a</div>
					<div className="datepicker datepicker-margin-right">
						<input
							type="text"
							id="endDateFilter"
							name="endDateFilter"
							className={`form-control no-shadow no-bold col-xs-8`}
							placeholder="Escolha uma data"
							data-input
							required
							maxLength={10}
							autoComplete="off"
							data-action="date-period-filter-end-date"
						/>
						<i className="icon-calendar" />
					</div>
				</div>
				<div className="col-xs-8 col-md-4 col-lg-3">
					<Button
						disabled={this.props.isDisabled}
						onClick={() => this.handleChangeDate(true)}
						className="btn btn-primary datepicker-margin-button"
					>
						<i className="icon-search" />
						Pesquisar
					</Button>
				</div>
			</div>
		);
	}
}

SalesDate.propTypes = {
	maxIntervalBetweenDates: PropTypes.number.isRequired,
	dateChanged: PropTypes.any,
	startDate: PropTypes.any,
	endDate: PropTypes.any
};

SalesDate.defaultProps = {
	maxIntervalBetweenDates: 365,
	startDate: new Date(),
	endDate: incDaysToDate(formatDateToComputerDate(new Date()), 365)
};
